import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';

import styles from './cms-shopping-categories.scss';

function CmsShoppingCategories(props) {
  const { categories } = props;

  return (
    <div>
      <ul className={styles['list']}>
        {Array.isArray(categories) &&
          categories.map((category, idx) => {
            const { image, link, type } = category || {};
            return (
              <li className={styles['category']} key={`csc-${idx}`}>
                <Link className={styles['link']} to={link?.href}>
                  <img
                    alt={image?.altText}
                    className={styles['image']}
                    src={image?.url}
                  />
                  <span className={styles['type']}>{type}</span>
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

CmsShoppingCategories.propTypes = {
  categories: PropTypes.array
};

export default CmsShoppingCategories;
